import React from 'react';

import Recaptcha from 'react-google-recaptcha';
import DatePicker from 'react-datepicker';
import moment from 'moment';

const input = function (field) {
  // Define stateless component to render input and errors
  let classes = ['form-group'].concat(field.wrapperClassName);
  if (field.inlineLabel) {
    classes.push('inline-group');
  }
  if (field.meta.touched && field.meta.error) {
    //add validation classes
    classes.push('has-error');
  }

  let labelClasses = ['control-label'];
  if (field.hideLabel) {
    labelClasses.push('sr-only');
  }

  let inputClasses = ['form-control'];
  if (field.inlineLabel) {
    inputClasses.push('inline');
  }

  return (
    <div className={classes.join(' ')}>
      <label htmlFor={field.name} className={labelClasses.join(' ')}>
        {field.label}
      </label>

      <input
        type={field.type}
        className={inputClasses.join(' ')}
        placeholder={field.placeholder ? field.placeholder : field.label}
        {...field.input}
      />
    </div>
  );
};

const dateOnBlur = (onBlur, event) => {
  var objDate = moment(event.target.value);
  if (objDate.isValid()) {
    event.target.value = moment(event.target.value).toISOString();
  } else {
    event.target.value = '';
  }

  onBlur(event);
};

const date = (field) => {
  // Define stateless component to render input and errors
  let classes = ['form-group', 'date'].concat(field.wrapperClassName);
  if (field.inlineLabel) {
    classes.push('inline-group');
  }
  if (field.meta.touched && field.meta.error) {
    //add validation classes
    classes.push('has-error');
  }

  let labelClasses = ['control-label'];
  if (field.hideLabel) {
    labelClasses.push('sr-only');
  }

  let inputClasses = ['form-control'];
  if (field.inlineLabel) {
    inputClasses.push('inline');
  }

  return (
    <div className={classes.join(' ')}>
      <label htmlFor={field.name} className={labelClasses.join(' ')}>
        {field.label}
      </label>
      <DatePicker
        {...field.input}
        onBlur={dateOnBlur.bind(null, field.input.onBlur)}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        className={inputClasses.join(' ')}
        selected={
          field.input.value && moment(field.input.value).isValid()
            ? moment(field.input.value)
            : null
        }
        placeholderText={field.placeholder}
      />
    </div>
  );
};

const textarea = function (field) {
  // Define stateless component to render input and errors
  let classes = ['form-group'].concat(field.wrapperClassName);

  if (field.meta.touched && field.meta.error) {
    //add validation classes
    classes.push('has-error');
  }

  let labelClasses = ['control-label'];
  if (field.hideLabel) {
    labelClasses.push('sr-only');
  }

  let inputClasses = ['form-control'];
  if (field.inlineLabel) {
    inputClasses.push('inline');
  }

  return (
    <div className={classes.join(' ')}>
      <label htmlFor={field.name} className={labelClasses.join(' ')}>
        {field.label}
      </label>

      <textarea
        className={inputClasses.join(' ')}
        placeholder={field.placeholder ? field.placeholder : field.label}
        {...field.input}
      />
    </div>
  );
};

const select = function (field) {
  // Define stateless component to render input and errors
  let classes = ['form-group'].concat(field.wrapperClassName);

  if (field.meta.touched && field.meta.error) {
    //add validation classes
    classes.push('has-error');
  }

  let labelClasses = ['control-label'];
  if (field.hideLabel) {
    labelClasses.push('sr-only');
  }

  let inputClasses = ['form-control'];
  if (field.inlineLabel) {
    inputClasses.push('inline');
  }

  return (
    <div className={classes.join(' ')}>
      <label htmlFor={field.name} className={labelClasses.join(' ')}>
        {field.label}
      </label>
      <div className="select-wrapper">
        <select
          type={field.type}
          className={inputClasses.join(' ')}
          {...field.input}
        >
          {[
            <option key=" " value="" disabled>
              {field.placeholder ? field.placeholder : field.label}
            </option>,
          ].concat(field.children)}
        </select>
      </div>
    </div>
  );
};

const booleanRadio = function (field) {
  const { label, input, meta, wrapperClassName, notInline } = field;

  let wrapperClasses = ['form-group'];
  let firstStyle = { marginLeft: 0 };
  if (!notInline) {
    wrapperClasses.push('inline-group');
    firstStyle = {};
  }

  if (wrapperClassName) {
    wrapperClasses = wrapperClasses.concat(wrapperClassName.split(' '));
  }

  if (meta.touched && meta.error) {
    //add validation classes
    wrapperClasses.push('has-error');
  } else if (meta.touched) {
    wrapperClasses.push('has-success');
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      <label className="control-label no-caps required">{label}</label>
      <label className="no-caps radio-inline" style={firstStyle}>
        <input
          {...input}
          type="radio"
          value={'true'}
          checked={input.value == 'true'}
        />
        <span />
        Yes
      </label>
      <label className="radio-inline no-caps">
        <input
          {...input}
          type="radio"
          value={'false'}
          checked={input.value == 'false'}
        />
        <span />
        No
      </label>
    </div>
  );
};

const ageRadio = function (field) {
  const { label, input, meta, wrapperClassName, notInline } = field;

  let wrapperClasses = ['form-group'];
  let firstStyle = { marginLeft: 0 };
  if (!notInline) {
    wrapperClasses.push('inline-group');
    firstStyle = {};
  }

  if (wrapperClassName) {
    wrapperClasses = wrapperClasses.concat(wrapperClassName.split(' '));
  }

  if (meta.touched && meta.error) {
    //add validation classes
    wrapperClasses.push('has-error');
  } else if (meta.touched) {
    wrapperClasses.push('has-success');
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      <label className="control-label no-caps required">{label}</label>
      <label className="no-caps radio-inline" style={firstStyle}>
        <input
          {...input}
          type="radio"
          value={'true'}
          checked={input.value == 'true'}
        />
        <span />
        18 years or older
      </label>
      <label className="radio-inline no-caps">
        <input
          {...input}
          type="radio"
          value={'false'}
          checked={input.value == 'false'}
        />
        <span />
        16 or 17 years old
      </label>
    </div>
  );
};

const recaptcha = function (field) {
  return (
    <Recaptcha
      sitekey="6LelCCoTAAAAAD89tgnFLMw2Lys8bpMD1cLyFVtc"
      onChange={field.input.onChange}
    />
  );
};

export default {
  input,
  textarea,
  select,
  recaptcha,
  booleanRadio,
  ageRadio,
  date,
};
